export interface ShopEnv {
    botProtS3UrlPrefix: string;
    botProtStatus: 'forced' | 's3' | 'disabled';
    waasCustomerId: string;
    waasVisitorContainerHostname: string;
}

export function useEnv(): ShopEnv {
    return {
        botProtS3UrlPrefix: parseBotProtS3UrlPrefix(
            process.env.VUE_APP_BOT_PROT_S3_URL
        ),
        botProtStatus: parseBotProtStatus(process.env.VUE_APP_BOT_PROT_STATUS),
        waasCustomerId: process.env.VUE_APP_WAAS_CUSTOMER_ID,
        waasVisitorContainerHostname:
            process.env.VUE_APP_WAAS_VISITOR_CONTAINER_HOSTNAME,
    };
}

export type ShopEnvBotProtStatus = 'forced' | 's3' | 'disabled';

function parseBotProtStatus(status: string | undefined): ShopEnvBotProtStatus {
    function isBotProtStatus(
        status: string | undefined | null
    ): status is ShopEnvBotProtStatus {
        return !!status && ['disabled', 'forced', 's3'].includes(status);
    }

    return isBotProtStatus(status) ? status : 's3';
}

function parseBotProtS3UrlPrefix(value: string | undefined | null): string {
    return value || 'https://ev3b.s3.eu-west-1.amazonaws.com/botprot/';
}
